import { render, staticRenderFns } from "./PropecInfoTextLayout.vue?vue&type=template&id=a1daece8"
import script from "./PropecInfoTextLayout.vue?vue&type=script&lang=js"
export * from "./PropecInfoTextLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports